<template>
  <app-carousel :item-width="320" :items="list">
    <template #item="{ item }">
      <div class="h-full">
        <event-card class="h-full w-full" :event="item" />
      </div>
    </template>
  </app-carousel>
</template>

<script lang="ts" setup>
import type { EventListView } from "~/business-areas/event/composables/event-list.hook";

defineProps<{
  list: EventListView[];
}>();
</script>
